module.exports = __webpack_public_path__ + "ms.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ms.svg
// module id = 705
// module chunks = 0